import React from 'react';
import { Evidence } from '@eas/common-web';
import { useColumns } from '../loan-columns';
import { useLoans } from '../loans';

export function LoansAll() {
  const columns = useColumns();
  const { evidenceBag } = useLoans({
    evidenceProps: {
      tableProps: {
        columns: [...columns],
      },
    },
  });
  return <Evidence {...evidenceBag} />;
}
